import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CONSTANT_MESSAGES } from '../../constants/constants-messages';

@Component({
    selector: 'app-logout',
    templateUrl: '../signin/signin.component.html',
    styleUrls: ['../signin/signin.component.css'],
    providers: []
})
export class LogoutComponent implements OnInit {
    private _router;
    private stringConstants = CONSTANT_MESSAGES;
    private vendor = {
        emailId: '',
        password: ''
    };
    public appVersion: any;

    /**
     * Creates an instance of LogoutComponent.
     *
     * Removed all items in localstorage
     * @param {Router} router
     *
     * @memberof LogoutComponent
     */
    constructor(private router: Router) {
        this.appVersion = localStorage.getItem('appVersion');
        this._router = router;
        localStorage.removeItem('vendor');
        localStorage.removeItem('currentCategory');
        localStorage.removeItem('facility');
        localStorage.removeItem('facilityList');
        localStorage.removeItem('vendor_facilityData');
        localStorage.removeItem('category');
        localStorage.removeItem('memberUserId');
        localStorage.removeItem('recentCreatedGroupId');
        localStorage.removeItem('Wizard');
        localStorage.removeItem('needPopup');
        localStorage.removeItem('view');
        localStorage.removeItem('summaryViewRequest');
        localStorage.removeItem('memberEmailId');
        localStorage.removeItem('hidescrollbar');
        localStorage.removeItem('facilityIdOnViewSummary');
        localStorage.removeItem('calendarDate');
        localStorage.removeItem('memberSummary');
        localStorage.removeItem('selectedEndDate');
        localStorage.removeItem('selectedStartDate');
        this._router.navigate(['/']);
        // setTimeout(function () {
        //     location.reload();
        // },0);
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/logout/logout.component.ts